import { render, staticRenderFns } from "./Offer.vue?vue&type=template&id=addf7b52"
import script from "./Offer.vue?vue&type=script&lang=js"
export * from "./Offer.vue?vue&type=script&lang=js"
import style0 from "./Offer.vue?vue&type=style&index=0&id=addf7b52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports